import * as React from "react";
import { useState } from 'react';
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { OrderSetupReview } from "../../../Common/Review/Component/OrderSetupReview";
import { Urls } from "../../../../../Urls";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ITableConfig, Table } from "../../../../../../Shared/Table/Table";
import { Order } from "../../../../../../../Wrap/Models/Domains/Orders/Order";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { BuyAction } from "../../Action/BuyAction";
import { Action } from "../../../../../Actions/Action";
import { BatchInfoModel } from "../../../../../../../Wrap/Models/Domains/Orders/Batch/BatchInfoModel";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { hasDecisionMaker, equlityBondWarning } from "../../../Switch/Resource/Content";
import { DownloadButton } from "../../../../../../Shared/DownloadButton/DownloadButton";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { CommissionChargeCancelMsg } from "../../../Common/AdviserCharges/Components/CommissionChargeCancelMsg";
import { ExternalFundDocument } from "../../../Common/Documents/Components/ExternalFundDocument";
import { OrderStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/OrderStatus";
import { AccountRoleStore } from "../../../../../Stroes/Variable";
import { CustomerTaxResidencyModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { ClientRecordAction } from "../../../ClientRecord/Action/ClientRecordAction";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { CashProductDeclarations } from "../../../Common/Review/Component/CashProductDeclarations";

interface IReviewProps extends IProcessComponentProps {
    type: SubAccountType;
    onClearError: VoidFunction;
}

interface IReviewState {
    isLoadingInvestmentList: boolean | null;
    investmentList: Array<Order>;
    residency: Array<CustomerTaxResidencyModel>;
    isvalid: boolean;
    isCashDeclarationChecked: boolean | null;
}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoadingInvestmentList: true,
            investmentList: [],
            residency: [],
            isvalid: true,
            isCashDeclarationChecked: false
        };
    }

    private navigate() {
        this.props.onClearError();
        Navigator.navigateTo(Urls.get().BuyInvestmentSelection, {
            scrollAfterNavigating: true,
            queryParamsObject: {
                claccountid: getQueryParameters()["claccountid"],
                hierarchyid: getQueryParameters()["hierarchyid"],
                subaccounthierarchyid: getQueryParameters()["subaccounthierarchyid"],
                batchId: this.props.data.BatchId,
            },
        });
    }

    handleCashDeclarationChange = (event) => {
        this.setState({ isCashDeclarationChecked: event });
      };

    private getTableColumn() {
        const tableColConfig: ITableConfig[] = [
            {
                title: "Investment",
                key: "Description",
                render: (data, row: Order, index) => {
                    return row.Description;
                },
                thCssWrapper: "cell-left",
                tdCssWrapper: "cell-left",
            },
            {
                title: "Buy value",
                key: "OrderValue",
                render: (data, row: Order, index) => {
                    return MoneyDisplayHelper.FromatMoneyDisplay(row.OrderValue, CurrencyCode.GBP, true, 2);
                },
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",
            },
            {
                title: "Buy quantity",
                key: "OrderQuantity",
                render: (data, row: Order, index) => {
                    return MoneyDisplayHelper.FromatMoneyDisplay(row.OrderQuantity, null, false, 4);
                },
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",
            },

            {
                title: "Limit price",
                key: "OrderLimit",
                render: (data, row: Order, index) => {
                    return MoneyDisplayHelper.FromatMoneyDisplay(row.OrderLimit, null, false, 2);
                },
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",
            },
            {
                title: "Status",
                key: "OrderStatus",
                render: (data, row: Order, index) => {
                    return row.OrderStatus;
                },
                thCssWrapper: "cell-right",
                tdCssWrapper: "cell-right",
            },
        ]; // all table column config

        return tableColConfig;
    }

    componentDidMount() {
        super.componentDidMount();

        this.setState({ isLoadingInvestmentList: true });
        BuyAction.getBatchInfo(
            this.props.data,
            (callBack: BatchInfoModel) => {
                this.setState({ isLoadingInvestmentList: false });
                if (callBack?.InvestmentList?.length > 0) {
                    this.setState({
                        investmentList: callBack.InvestmentList,
                    });
                }
            },
            () => {
                this.setState({ isLoadingInvestmentList: false });
            }
        );
        const accountRoles = AccountRoleStore.getAccountRoles();
        ClientRecordAction.getCutomerTaxResidency(accountRoles[0].Customer.CustomerId, (val) => {
            this.setState({
                residency: val,
            });
        });
    }

    private renderDocuments() {
        const claccountid = getQueryParameters()["claccountid"];
        const headAccountHierarchyId = getQueryParameters()["hierarchyid"];
        const chargesInformationQuery = DocumentsHelper.getTaskRequestForChargeInformation(
            this.props.data.BatchId,
            claccountid,
            DocumentTaskRequestTypeEnum.ChargesInformation
        );
        const config = [
            {
                title: (
                    <div className="mb-24">
                        <a className="hyperlink">Charges Information</a>
                        <DownloadButton
                            request={chargesInformationQuery}
                            selectedAccount={headAccountHierarchyId}
                        ></DownloadButton>
                    </div>
                ),
                data: " ",
            },
        ];
        return (
            <>
                <Typography type="wider" wrapCss="narrow-margin no-print" config={config}></Typography>
            </>
        );
    }

    isValid() {
        const flag = super.isValid();
        const validRsidency = this.state.residency.some((x) => x.PrimaryCitizenship || x.IsNationality);

        if (hasDecisionMaker(this.props.data.InvestmentList) && !validRsidency) {
            this.props.showErrorMsgPopUp(
                [
                    "In order to invest in a MiFIR reportable instrument, One of your Primary citizenship or Nationality is yes",
                ],
                true
            );
            return false;
        }
        if (this.state.investmentList.some((x) => x.SecurityType == "Cash Product") && this.state.isCashDeclarationChecked == false) {
            this.props.showErrorMsgPopUp(
                [
                    "In order to invest in a cash deposit you must accept the declaration",
                ],
                true
            );
            return false;
        }
        return flag;
    }

    public render(): JSX.Element {
        const { data, type } = this.props;
        const investmentList = this.state.investmentList;
        let orderList = investmentList.filter((o) => o.Status === OrderStatus.Created);    
        let total = investmentList.reduce((total, ele) => total + ele.OrderValue, 0);
        if (data?.InvestmentList.some((item) => item?.InstrumentCode === "GBPCash")) {
            const cash = data?.InvestmentList?.find((item) => item?.InstrumentCode === "GBPCash");
            orderList.unshift({
                Description: 'GBPCash',
                OrderValue: cash?.OrderValue,
                OrderQuantity: cash?.OrderQuantity,
                OrderStatus: 'Created'
            })

            total += cash?.OrderValue;
        }
        const instrumentCodes: Array<string> = data.InvestmentList.map((item) => item?.InstrumentCode);
        return (
            <>
                {hasDecisionMaker(data.InvestmentList) && (
                    <Alert alertType={AlertType.Warning} message={equlityBondWarning} />
                )}
                <h2 className="mb-18">
                    <span>Review</span>
                </h2>
                <CommissionChargeCancelMsg processType={ProcessType.Buy} />
                <div>
                    <div className="d-flex flex-space">
                        <h2 className="mb-11">Order setup</h2>
                        <button
                            className="edit-circle-icon-button label-sr-only"
                            title="Edit"
                            onClick={() => {
                                this.props.onClearError();
                                Navigator.navigateTo(Urls.get().BuyOrderSetup, {
                                    scrollAfterNavigating: true,
                                    queryParamsObject: {
                                        claccountid: getQueryParameters()["claccountid"],
                                        hierarchyid: getQueryParameters()["hierarchyid"],
                                        subaccounthierarchyid: getQueryParameters()["subaccounthierarchyid"],
                                        batchId: data.BatchId,
                                    },
                                });
                            }}
                        >
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">Edit</span>
                        </button>
                    </div>
                    <hr className="heading-underlined-text"></hr>
                    <OrderSetupReview process={ProcessType.Buy} subAccountType={type} data={data} colNum={2} />
                </div>
                {/* <Accordion
                    label="Order setup"
                    isOpen={true}
                    onEdit={() => {
                        this.props.onClearError();
                        Navigator.navigateTo(Urls.get().BuyOrderSetup, {
                            scrollAfterNavigating: true,
                            queryParamsObject: {
                                claccountid: getQueryParameters()["claccountid"],
                                hierarchyid: getQueryParameters()["hierarchyid"],
                                subaccounthierarchyid: getQueryParameters()["subaccounthierarchyid"],
                                batchId: data.BatchId,
                            },
                        });
                    }}
                >

                </Accordion> */}
                <div>
                    <div className="d-flex flex-space">
                        <h2 className="mb-11">Buy investments</h2>
                        <button
                            className="edit-circle-icon-button label-sr-only"
                            onClick={() => this.navigate()}
                            title="Edit"
                        >
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">Edit</span>
                        </button>
                    </div>
                    <hr className="heading-underlined-text"></hr>
                    <Table
                        data={orderList}
                        cssWrapper="no-sided-padding no-borders bg-default"
                        col={this.getTableColumn()}
                        isLoading={this.state.isLoadingInvestmentList === true}
                        TotalBody={[
                            { data: "Estimated total buy trade value", colSpan: 1 },
                            {
                                data: MoneyDisplayHelper.FromatMoneyDisplay(total, CurrencyCode.GBP, true, 2),
                                tfTdCssWrapper: "cell-right pr-12",
                                colSpan: 0,
                            },
                        ]}
                        SubBody={[
                            { data: "Estimated net order value", colSpan: 1 },
                            {
                                data: MoneyDisplayHelper.FromatMoneyDisplay(total * -1, CurrencyCode.GBP, true, 2),
                                tfTdCssWrapper: "cell-right pr-12",
                                colSpan: 0,
                            },
                        ]}
                    />
                </div>

                <hr className="mb-33" />
                <h3 className="mb-7 h4">Explaining charges to your client</h3>
                <p className="mb-10">
                    It's important that your client understands the costs and charges they will incur based on their
                    investment choices. The Charges Information Document provides the aggregated costs and charges for
                    your client's investment.
                </p>
                {this.renderDocuments()}

                <ExternalFundDocument instrumentCodes={instrumentCodes} {...this.props} />
                <div className="no-print">
                    <CheckboxEditor
                        value={data.AdviceGiven}
                        onChange={(v) => {
                            this.props.onChange({ AdviceGiven: v });
                        }}
                        label="Please indicate if advice was given on this trade."
                        cssWrapper="square-checkbox block"
                    ></CheckboxEditor>
                </div>
                {
                    investmentList.some((x) => x.SecurityType == "Cash Product") &&
                    <CashProductDeclarations
                        instrumentCodes={investmentList
                            .filter(x => x.SecurityType === "Cash Product")
                            .map(x => x.InstrumentCode)}
                        isCashDeclarationChecked={this.state.isCashDeclarationChecked}
                        onCashDeclarationChanged={this.handleCashDeclarationChange}
                    />
                }
            </>
        );
    }
}
